module.exports = __webpack_public_path__ + "img/Pot1.8c135476.svg";